module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "checkout-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Checkout")]), _vm._v(" "), (_vm.cart.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('p', [_vm._v("Your cart is empty. Please add items before checking out.")]), _vm._v(" "), _c('button', {
    staticClass: "btn-back",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n          Back to Shop\n        ")])]) : _c('div', {
    staticClass: "checkout-content"
  }, [_c('div', {
    staticClass: "checkout-form"
  }, [_c('div', {
    staticClass: "form-section"
  }, [_c('h2', [_vm._v("Shipping Information")]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("First Name *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.first_name),
      expression: "shipping.first_name"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.first_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Last Name *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.last_name),
      expression: "shipping.last_name"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.last_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.email),
      expression: "shipping.email"
    }],
    attrs: {
      "type": "email",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.phone),
      expression: "shipping.phone"
    }],
    attrs: {
      "type": "tel",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Address Line 1 *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.address_line1),
      expression: "shipping.address_line1"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.address_line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.address_line1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Address Line 2")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.address_line2),
      expression: "shipping.address_line2"
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.address_line2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.address_line2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.city),
      expression: "shipping.city"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.city = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State/Province *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.state),
      expression: "shipping.state"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.state = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Postal Code *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.postal_code),
      expression: "shipping.postal_code"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.postal_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.postal_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Country *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.country),
      expression: "shipping.country"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.country = $event.target.value
      }
    }
  })])])]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n            " + _vm._s(_vm.error) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.processing) ? _c('div', {
    staticClass: "processing-message"
  }, [_vm._v("\n            " + _vm._s(_vm.processingMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.processing && !_vm.orderCreated) ? _c('div', [_c('div', {
    ref: "paypalButtons",
    staticClass: "paypal-button-container",
    attrs: {
      "id": "paypal-button-container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Spacer-module_divider__ewqEj"
  }, [_c('span', [_vm._v("OR")])]), _vm._v(" "), _c('div', {
    staticClass: "card_container",
    attrs: {
      "id": "card-form"
    }
  }, [_c('div', {
    staticClass: "card_field",
    attrs: {
      "id": "card-name-field-container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card_field",
    attrs: {
      "id": "card-number-field-container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card_field_50",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "id": "card-expiry-field-container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card_field_50",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "id": "card-cvv-field-container"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "id": "card-field-submit-button",
      "type": "button",
      "disabled": _vm.cardSubmitDisabled
    },
    on: {
      "click": function($event) {
        _vm.submitCardPayment()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.cardSubmitDisabled ? 'Processing...' : ("Pay $" + (_vm.formatPrice(_vm.cartTotal)))) + "\n              ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "order-summary"
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('h2', [_vm._v("Order Summary")]), _vm._v(" "), _c('div', {
    staticClass: "summary-items"
  }, _vm._l((_vm.cart), function(item) {
    return _c('div', {
      key: item.variantId,
      staticClass: "summary-item"
    }, [_c('div', {
      staticClass: "summary-item-image"
    }, [(item.image) ? _c('img', {
      attrs: {
        "src": item.image,
        "alt": item.name
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "summary-item-details"
    }, [_c('div', {
      staticClass: "summary-item-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "summary-item-variants"
    }, [(item.color) ? _c('span', [_vm._v(_vm._s(item.color))]) : _vm._e(), _vm._v(" "), (item.size) ? _c('span', [_vm._v(_vm._s(item.size))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "summary-item-qty"
    }, [_vm._v("Qty: " + _vm._s(item.quantity))])]), _vm._v(" "), _c('div', {
      staticClass: "summary-item-price"
    }, [_vm._v("\n                  $" + _vm._s(_vm.formatPrice(item.price * item.quantity)) + "\n                ")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "summary-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Subtotal")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.cartTotal)))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Shipping")]), _vm._v(" "), _c('span', {
    staticClass: "free-shipping"
  }, [_vm._v("FREE")])]), _vm._v(" "), _c('div', {
    staticClass: "summary-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "summary-row total"
  }, [_c('span', [_vm._v("Total")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.cartTotal)))])])]), _vm._v(" "), _c('button', {
    staticClass: "btn-back-to-cart",
    on: {
      "click": function($event) {
        _vm.$router.push('/cart')
      }
    }
  }, [_vm._v("\n            ← Back to Cart\n          ")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08e6d604"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Checkout.vue
// module id = 273
// module chunks = 1